import { AlertTriangle, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Pill, Section } from "@/components/common";
import { cn } from "@/lib/utils";

const STATE_LABELS = {
  work: { none: "Aucun travail", pending: "À faire", in_progress: "En cours", done: "Terminés" },
  quote: { none: "Aucun devis", draft: "Brouillon", sent: "En attente d'accord", accepted: "Accepté", refused: "Refusé", expired: "Expiré" },
  parts: { none: "Aucune pièce", to_check: "À réserver", waiting: "En attente", ready: "Disponibles" },
  quality_control: { none: "—", pending: "À valider", validated: "Validé" },
  invoice: { none: "Non facturé", draft: "Brouillon", issued: "Émise" },
  payment: { none: "—", unpaid: "Impayée", partial: "Partiel", paid: "Payée" },
};
const GOOD = { work: ["done"], quote: ["accepted"], parts: ["ready", "none"], quality_control: ["validated"], invoice: ["issued"], payment: ["paid"] };
const WARN = { work: ["in_progress"], quote: ["sent", "draft"], parts: ["waiting", "to_check"], quality_control: ["pending"], invoice: ["draft"], payment: ["unpaid", "partial"] };
const TITLES = { work: "Travaux", quote: "Devis", parts: "Pièces", quality_control: "Contrôle qualité", invoice: "Facture", payment: "Paiement" };

export function RoStatesStrip({ states }) {
  if (!states) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="ro-states-strip">
      {Object.keys(TITLES).map((k) => {
        const v = states[k];
        const cls = GOOD[k].includes(v) ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-500" : WARN[k].includes(v) ? "border-amber-500/40 bg-amber-500/10 text-amber-500" : "border-border text-muted-foreground";
        return <Pill key={k} className={cls} testId={`ro-state-${k}`}><span className="mr-1 opacity-70">{TITLES[k]} :</span>{STATE_LABELS[k][v] || v}</Pill>;
      })}
    </div>
  );
}

export function RoBlockers({ blockers = [], nextAction, onAction, busy }) {
  const high = blockers.filter((b) => b.severity === "high").length;
  return (
    <Section title="Blocages & prochaine action" testId="ro-blockers" className="rise border-primary/20">
      {nextAction && (
        <Button onClick={() => onAction?.(nextAction)} disabled={busy || nextAction.kind === "none"} className="mb-3 h-11 w-full justify-between rounded-xl font-semibold" data-testid="ro-next-action-button">
          <span className="truncate">{nextAction.label}</span><ArrowRight className="ml-2 h-4 w-4 shrink-0" />
        </Button>
      )}
      {!blockers.length ? (
        <div className="flex items-center gap-2 text-sm text-emerald-500" data-testid="ro-no-blockers"><CheckCircle2 className="h-4 w-4" /> Aucun blocage : le dossier peut avancer.</div>
      ) : (
        <ul className="space-y-2" data-testid="ro-blockers-list">
          {blockers.map((b) => (
            <li key={b.code} className={cn("flex items-start gap-2 rounded-lg border px-3 py-2 text-sm", b.severity === "high" ? "border-red-500/40 bg-red-500/5" : b.severity === "medium" ? "border-amber-500/40 bg-amber-500/5" : "border-border")} data-testid={`ro-blocker-${b.code}`}>
              <AlertTriangle className={cn("mt-0.5 h-4 w-4 shrink-0", b.severity === "high" ? "text-red-500" : b.severity === "medium" ? "text-amber-500" : "text-muted-foreground")} />
              <div><div className="font-medium">{b.label}</div>{b.detail && <div className="text-xs text-muted-foreground">{b.detail}</div>}</div>
            </li>
          ))}
        </ul>
      )}
      {high > 0 && <p className="mt-2 text-xs text-red-500">{high} blocage(s) critique(s) : le véhicule ne peut pas avancer sans action.</p>}
    </Section>
  );
}
